import React from 'react';
import Modal from 'react-bootstrap/Modal';

import {ArrowGreenLeft, CloseIconGray} from '../../styles/icons/index';

const BottomSheetPopUpModal = ({
    showModal,
    modalContentHeader,
    children,
    size = 'md',
    modalClass = '',
    dialogClass = '',
    modalBodyClass = '',
    modalHeaderClass = '',
    showCloseIcon = false,
    toggleModal = () => {},
    modalContentHeaderClass = '',
    showBackIcon = false,
    modalGoBackLabel = '',
    onClickBackIcon,
    fullHeight,
    headerSlot,
    contentClassName,
    backdrop
}) => {
    return (
        <Modal
            show={showModal}
            onHide={toggleModal}
            centered
            size={size}
            className={`bottom-sheet-popup-modal ${modalClass} ${fullHeight ? 'full-height' : ''}`}
            dialogClassName={dialogClass}
            contentClassName={contentClassName}
            backdrop={backdrop}
        >
            {headerSlot || (
                <Modal.Header className={modalHeaderClass}>
                    {showCloseIcon && (
                        <div
                            className={`d-flex ${
                                showBackIcon ? 'justify-content-between align-items-center' : 'justify-content-end'
                            } w-100`}
                        >
                            {showBackIcon && (
                                <div className='go-back-wrapper cursor-pointer' onClick={onClickBackIcon}>
                                    <ArrowGreenLeft className='go-back-icon' />
                                    <span className='go-back-label'>{modalGoBackLabel}</span>
                                </div>
                            )}
                            <CloseIconGray className='close-button' onClick={toggleModal} />
                        </div>
                    )}
                    {modalContentHeader && <div className={modalContentHeaderClass}>{modalContentHeader}</div>}
                </Modal.Header>
            )}
            <Modal.Body className={modalBodyClass}>{children}</Modal.Body>
        </Modal>
    );
};

export default BottomSheetPopUpModal;
